<app-text-deliverable
  [form]="form()"
  [platformFeature]="platformFeature()"
  [creatorId]="creatorId()"
  [ctaTemplateId]="ctaTemplateId()"
  [isCustomMode]="isCustomMode()"
  [creators]="creators()"
  [isParentDeleteDisabled]="isParentDeleteDisabled()"
  [lastActiveElementDetails]="lastActiveElementDetails()"
  [isExpanded]="isExpanded()"
  [isViewMode]="isViewMode()"
  [creatorBriefingMode]="creatorBriefingMode()"
  [showRequiredBadge]="showRequiredBadge()"
  [showStatusBadge]="showStatusBadge()"
  [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
  [analyticsBadgeLoading]="analyticsBadgeLoading()"
  [analyticsKeywordCounts]="analyticsKeywordCounts()"
  [analyticsKeywordJump]="analyticsKeywordJump()"
  [analyticsKeywordJumpTargets]="analyticsKeywordJumpTargets()"
  [analyticsKeywordJumpTargetsReady]="analyticsKeywordJumpTargetsReady()"
  [textDeliverableConfig]="chatbotMultiTextConfig"
  [extraManagedFields]="intervalManagedFields"
  (delete)="delete.emit()"
  (parentCheckboxChange)="parentCheckboxChange.emit($event)"
>
  <!-- Interval fields projected into the ng-content[chatbotIntervals] slot.
       [formGroup]="form()" is required here because Angular content projection
       uses the declaring component's injector (ChatbotMultiComponent), not the
       host's — so formControlName must find its ControlContainer locally. -->
  <div chatbotIntervals [formGroup]="form()" class="flex flex-col mb-5">
    <div class="flex gap-3">
      <div class="flex flex-[0.5]">
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.chatbotMultiDeliverable.minInterval' | translate }}
          </mat-label>
          <input matInput type="text" formControlName="minInterval" numberOnly />
          <div matSuffix class="flex items-center gap-1">
            <span class="text-[10px]">{{ 'shared.timeSuffixLong.minutes' | translate }}</span>
            @if (statusMinInterval() && isViewMode()) {
              <app-status-badge [status]="statusMinInterval()!" colorScheme="deliverable" />
            }
          </div>

          <mat-error fieldName="minInterval" [control]="minInterval" />
        </mat-form-field>
      </div>

      <div class="flex flex-[0.5]">
        <mat-form-field class="w-full">
          <mat-label>
            {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.chatbotMultiDeliverable.maxInterval' | translate }}
          </mat-label>
          <input matInput type="text" formControlName="maxInterval" numberOnly />
          <div matSuffix class="flex items-center gap-1">
            <span class="text-[10px]">{{ 'shared.timeSuffixLong.minutes' | translate }}</span>
            @if (statusMaxInterval() && isViewMode()) {
              <app-status-badge [status]="statusMaxInterval()!" colorScheme="deliverable" />
            }
          </div>
          <mat-error fieldName="maxInterval" [control]="maxInterval" />
        </mat-form-field>
      </div>
    </div>
  </div>
</app-text-deliverable>
